import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import './CookieConsent.css';

const CookieConsent: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setOpen(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      className="cookie-consent-dialog"
      PaperProps={{
        className: "cookie-consent-paper"
      }}
    >
      <DialogTitle className="cookie-consent-title">
        Cookie Notice
      </DialogTitle>
      <DialogContent>
        <DialogContentText className="cookie-consent-text">
          We use cookies to improve your experience on our website and to show you relevant advertising. 
          This includes cookies for analytics and advertising purposes. By continuing to use our site, 
          you consent to our use of cookies.
        </DialogContentText>
        <DialogContentText className="cookie-consent-text">
          You can learn more about how we use cookies in our Privacy Policy.
        </DialogContentText>
      </DialogContent>
      <DialogActions className="cookie-consent-actions">
        <Button 
          onClick={handleDecline} 
          variant="outlined"
          className="cookie-consent-decline"
        >
          Decline
        </Button>
        <Button 
          onClick={handleAccept} 
          variant="contained"
          className="cookie-consent-accept"
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CookieConsent;